
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/identity-verification/reporting",
      function () {
        return require("private-next-pages/docs/identity-verification/reporting.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/identity-verification/reporting"])
      });
    }
  